import { INormalizedBlacklist } from '../api/repositories/blacklist/blacklist.normalizer';
import { ActionsUnion, createAction } from '../helpers';

export enum EBlacklistActionType {
  GET = 'BLACKLIST/GET',
  GET_SUCCESS = 'BLACKLIST/GET_SUCCESS',
  POST = 'BLACKLIST/POST',
  POST_SUCCESS = 'BLACKLIST/POST_SUCCESS',
  DELETE = 'BLACKLIST/DELETE',
  DELETE_SUCCESS = 'BLACKLIST/DELETE_SUCCESS',
}

export const blacklistActions = {
  getBlacklist: () => createAction(EBlacklistActionType.GET),
  getBlacklistSuccess: (payload: INormalizedBlacklist) =>
    createAction(EBlacklistActionType.GET_SUCCESS, payload),
  postBlacklist: (receiverId: string) =>
    createAction(EBlacklistActionType.POST, {
      receiverId,
    }),
  postBlacklistSuccess: (receiverId: string) =>
    createAction(EBlacklistActionType.POST_SUCCESS, {
      receiverId,
    }),
  deleteBlacklist: (receiverId: string) =>
    createAction(EBlacklistActionType.DELETE, {
      receiverId,
    }),
  deleteBlacklistSuccess: (receiverId: string) =>
    createAction(EBlacklistActionType.DELETE_SUCCESS, {
      receiverId,
    }),
};

export type TBlacklistAction = ActionsUnion<typeof blacklistActions>;
